import React from 'react';

const InternalServerError = () => {
    return (
        <div style={{ marginTop: "15rem", fontSize: "35px" }}>
            <h1 style={{ marginLeft: "55rem", fontWeight: "bold", fontSize: "55px" }}>500 Error</h1>
            <h1 style={{ fontSize: "45px", marginLeft: "52rem" }}>Internal Server Error</h1>
            <a href={`${process.env.REACT_APP_BASE_DOMAIN_URL}/home`} target="" rel="noreferrer"><h3 style={{ fontSize: "45px", marginLeft: "52rem" }}>Return to Home Page</h3></a>

        </div>
    );
}

export default InternalServerError;